<template>
  <div class="header" :style="{ backgroundImage: `url('${headerImgPath}')`}">
    <div class="content">
      <a href="#">
        <img :src="iconImgPath"  alt="" />
      </a>
      <span class="game-name">{{gameName}}</span>
      <div class="rules">
        <!-- <div class="title">交易中心</div> -->
        <!-- <span class="word" @click="showCon()">活动说明</span>
        <div class="jiaobiao"></div> -->
      </div>
    </div>
    <el-dialog title="活动说明" :visible.sync="dialogVisible" width="70%">
      <p class="content">公众号中每消费1元可获得1积分</p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gameName: window.g.GAME_NAME,
      headerImgPath: require(`@/assets/image/${window.g.GAME_KEY}/header.png`),
      iconImgPath: require(`@/assets/image/${window.g.GAME_KEY}/icon.png`),
      dialogVisible: false,
    };
  },
  created() {
  },
  methods: {
    showCon() {
      this.dialogVisible = true;
    }
  },
};
</script>
<style lang="scss">
.header {
  .el-dialog {
    padding: 2vw;
    .content {
      color: #4d836c;
      font-size: 4vw;
    }
    .el-dialog__header {
      text-align: center;
      border-bottom: 0.4vw solid #4d836c;
      .el-icon-close {
        font-size: 8vw;
        position: absolute;
        right: 0;
        top: 1vw;
        color: #4d836c;
      }
      .el-dialog__title {
        color: #4d836c;
        font-size: 6vw;
        font-weight: 600;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.header {
  margin: 0 auto;
  align-items: center;
  height: 16vw;
  padding: 3vw;
  background: no-repeat;
  background-size: 100vw auto;
  .content {
    display: flex;
    align-items: center;
    a {
      margin-right: 4vw;
      width: 16vw;
      height: 16vw;
      img {
        width: 100%;
      }
    }

    .game-name {
      font-size: 6vw;
      color: #4d836c;
      transform: translateY(0.45vw);
      color: #ffffff;
    }
    .rules {
      margin-left: 28vw;
      .word {
        color: #ffffff;
        font-size: 3vw;
      }
      .jiaobiao {
        display: inline-block;
        font-size: 1vw;
        width: 0;
        height: 0;
        border-top: 1vw solid transparent;
        border-left: 1.2vw solid #ffffff;
        border-bottom: 1vw solid transparent;
      }
      .title {
        color: #ffffff;
        font-size: 4.8vw;
        height: 20%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/header.vue